import { APIState } from './../store/API/types';
import { ApplicationState } from './../store/index';
import { authFetch } from './../store/API/actions';
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { HeadersLoginInterface } from "../store/API/types";
import { doAuth, cancelAuth } from "../store/API/actions";

interface Args {
    user: React.RefObject<HTMLInputElement>,
    password: React.RefObject<HTMLInputElement>
}


const useDoAuth = ({user, password} : Args) => {
    const { authFetch } = useSelector<ApplicationState, APIState>(state => state.API);
    const dispatch = useDispatch();

    const oncancel = () => {
        if (authFetch) {
            dispatch(cancelAuth());
        } else {
            if (user.current) user.current.value = '';
            if (password.current) password.current.value = '';
        }
    };

    const onsubmit = (event?: React.FormEvent) => {
        if (event) event.preventDefault();
        const usernameVal = user.current ? user.current.value : '';
        const passwordVal = password.current ? password.current.value : '';

        const headers: HeadersLoginInterface = {
            username: usernameVal,
            password: passwordVal
        };

        window.localStorage.setItem('username', usernameVal);

        dispatch(doAuth(headers));
    };

    return { oncancel, onsubmit }
  };

  export default useDoAuth